import './App.css';
import { 
  useEffect, 
  useMemo,
} from 'react';
import { BrowserRouter } from "react-router-dom";
import { 
  createTheme, 
  ThemeProvider, 
  GlobalStyles,
} from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { 
  useDispatch, 
  useSelector,
} from 'react-redux';
import { 
  PatherProvider, 
  Pather, 
} from 'react-pather'
import { deepmerge } from "@mui/utils"; // Helps merge theme objects
import axios from 'axios';
import themes from './theme';
import { 
  frontRoutes, 
  backBoutes, 
} from './routes';
import {
  UUT,
  THEME_HEADER, 
  PRIMARY_COLOR_HEADER,
} from './config';
import Router from './routers/Router';
import { setUser } from './slices/userSlice';
import { setUserLoading } from './slices/userLoadingSlice';
import { AutoScrollToTop, CookieBanner } from './components/general';

const pather = new Pather(frontRoutes, backBoutes);

const App = () => {

  const mode = useSelector(state => state.theme.value);
  const user = useSelector(state => state.user.value);
  const jwt = useSelector(state => state.jwt.value);
  const uut = useSelector(state => state.token.value);
  const dispatch = useDispatch();

  // Copy existing theme & override primary color
  const theme = useMemo(
    () =>
      createTheme(
        deepmerge(themes[mode], {
          palette: {
            primary: { main: user.primaryColor },
          },
        })
      ),
    [mode, user.primaryColor]
  );

  useEffect(() => {
      // Authrorization header settings
      if(!!jwt){
        axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`; // <-| TODO: think whether it's good
      }
    
      // At the beginning `userLoading` state value is `true`, this call is for consistency
      dispatch(setUserLoading(true));

      // Current user restoration
      axios.get(pather.back.Auth.currentUser)
      .then(response => {
          console.log(response);
          const data = response.data;
          dispatch(setUser({
              isLogined: true,
              email: data.email,
              username: data.username,
              isConfirmed: data.is_confirmed,
              roles: data.roles,
              primaryColor: data.primary_color,
          }));
      })
      .catch(resp => {
        console.log(resp);
      })
      .finally(() => {
        dispatch(setUserLoading(false));
      });
  }, []);

  useEffect(() => {
    axios.defaults.headers.common[THEME_HEADER] = mode; 
  }, [mode]);

  useEffect(() => {
    axios.defaults.headers.common[PRIMARY_COLOR_HEADER] = user.primaryColor; 
  }, [user.primaryColor]);

  useEffect(() => {
    axios.defaults.headers.common[UUT] = uut;
  }, [uut]);

  return (
    <>
      <GlobalStyles styles={{
        body: { 
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.main,
        },
        '.MuiChartsTooltip-root *': {
          color: `${theme.palette.text.primary} !important`,
        },
      }}/>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3} autoHideDuration={3000} preventDuplicate={true}>
          <PatherProvider value={pather}>
            <BrowserRouter>
              <Router />
              <AutoScrollToTop />
              <CookieBanner />
            </BrowserRouter>
          </PatherProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </>
  );
}

export default App;